import Vue from 'vue';
import Router from 'vue-router';

import Posts from '@/router/posts.js';
import Favorites from '@/router/favorites.js';
import Sources from '@/router/sources.js';
import Info from '@/router/info.js';

Vue.use(Router);

let routes = [];

routes = routes.concat(Posts);
routes = routes.concat(Favorites);
routes = routes.concat(Sources);
routes = routes.concat(Info);

routes.push({
  path: '/*', // 404
  redirect: '/'
});

export default new Router({
  linkActiveClass: 'active',
  linkExactActiveClass: 'active',
  mode: 'history',
  scrollBehavior () {
    return {
      x: 0,
      y: 0
    };
  },
  routes
});
